export const privateItems = [
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049000',
    quantity: 0,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'another-one',
    type: 'private',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Y',
    updatedDisplayValue: '9/09/22'
  },
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049001',
    quantity: 5,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'second-one',
    type: 'private',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Y',
    updatedDisplayValue: '9/09/22'
  }
];

export const publicItems = [
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049000',
    quantity: 0,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'another-one',
    type: 'shared',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Z',
    updatedDisplayValue: '9/09/22'
  },
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049001',
    quantity: 5,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'another-one',
    type: 'shared',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Z',
    updatedDisplayValue: '9/09/22'
  }
];

export const publicAndPrivateItems = [
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049000',
    quantity: 0,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'first',
    type: 'private',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Y',
    updatedDisplayValue: '9/09/22'
  },
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049001',
    quantity: 0,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'second',
    type: 'shared',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Z',
    updatedDisplayValue: '9/09/22'
  },
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049002',
    quantity: 5,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'third',
    type: 'private',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Y',
    updatedDisplayValue: '9/09/22'
  },
  {
    orderId: '48971001',
    updated: 1662758049000,
    reactKey: '489710011662758049003',
    quantity: 0,
    createdBy: 'Brendan Beenham',
    lastUpdate: {
      unformattedDate: 'Sep 9, 2022 4:14:09 PM',
      formattedDate: '9/09/22'
    },
    name: 'fourth',
    type: 'shared',
    actions: [
      {
        deletelist: 'show',
        duplicatelist: 'show'
      }
    ],
    status: 'Z',
    updatedDisplayValue: '9/09/22'
  }
];

export const defaultSearchOptions = {
  folName: '',
  createdBy: '',
  itemPartNumber: '',
  startDate: '',
  endDate: ''
};
